import type { ITpoFlexBiometryData } from '@common/validation/customControls/tpoFlex/tpoFlexBiometrySchema';
import { CustomControlCode } from '@common/enums';
import { CustomControlRegistry } from '@frontend/components/pages/episodeCategory/customControls/customControlRegistry';
import { initialData } from './tpoFlexBiometryData';
import { TpoFlexBiometryEdit } from './TpoFlexBiometryEdit';
import { TpoFlexBiometryRead } from './TpoFlexBiometryRead';

CustomControlRegistry.instance.register<ITpoFlexBiometryData>({
    EditElement: TpoFlexBiometryEdit,
    ReadElement: TpoFlexBiometryRead,
    code: CustomControlCode.TPOFlexBiometry,
    initialData,
    version: 1,
});
